import React from 'react';

import Button from 'components/button/button';
import Typography from 'components/typography/typography';

import { createLocale } from 'locales';

import { useOrganisationJobDetail } from 'state/context/organization/OrganisationJobDetail';
import CancelJobDialog from 'pages/organization/OrganizationWeekPlannerPage/components/job-popover/cancel-job-dialog';
import useJobPopover from 'pages/organization/OrganizationWeekPlannerPage/components/job-popover/use-job-popover';

import useRedirect from 'hooks/use-redirect';

import JobPopover from 'pages/organization/OrganizationWeekPlannerPage/components/job-popover/job-popover';

const localize = createLocale('organizationPlannerJobDetailsLocales');

const Header: React.FC = () => {
  const {
    jobContext: { data: job },
  } = useOrganisationJobDetail();
  const jobPopover = useJobPopover(job);
  const redirect = useRedirect();

  const handleCancelJob = (reason?: string) => {
    jobPopover.onCancelDialogAcceptClicked(reason);
    redirect('/organisation/planner');
  };
  return (
    <>
      <div className="flex flex-col sm:flex-row justify-between w-full">
        <Typography as="h3" variant="title" className="mb-2 sm:mb-0">
          {localize('assignmentDetails')}
        </Typography>
        <div className="flex flex-col ml-2 md:ml-0 items-start md:flex-row md:justify-between gap-3 md:gap-6">
          <JobPopover
            job={job}
            button={
              <Button
                variant="outlined"
                label="options"
                leftIconProps={{
                  className: 'text-gray500',
                  icon: 'more',
                }}
                className="flex hover:outline hover:outline-1 hover:outline-gray100 active:outline active:outline-1 active:outline-gray100"
              />
            }
            actionsToDelete={['assignment-details', 'cancel-assignment']}
          />
          {jobPopover.displayCancelAction && (
            <Button
              variant="danger"
              label={localize('cancelOrder')}
              leftIconProps={{ className: 'text-white', icon: 'trash' }}
              onClick={() => jobPopover.setIsCancelDialogOpen(true)}
            />
          )}
        </div>
      </div>
      <CancelJobDialog
        isOpen={jobPopover.isCancelDialogOpen}
        onAcceptClicked={handleCancelJob}
        onBackClicked={() => jobPopover.setIsCancelDialogOpen(false)}
        onCloseClicked={() => jobPopover.setIsCancelDialogOpen(false)}
        variant={jobPopover.cancelJobDialogVariant}
        job={{
          competence: job.competence,
          date: job.date,
          end: job.end,
          freelancer: job.assigned_to?.name,
          location: job.location.name,
          start: job.start,
        }}
      />
    </>
  );
};

export default Header;
